import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=6476fb74&scoped=true"
import script from "./PreviewVideo.vue?vue&type=script&lang=js"
export * from "./PreviewVideo.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=6476fb74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476fb74",
  null
  
)

export default component.exports